import Cookies from "js-cookie"

const state = {
	CON_LOCATION: "baoxiao.gzshell.com",
	openUPDATE: true,
	isCollapse: false,
	BASE_API: window.location.host == "localhost:8002" ? "https://baoxiao.gzshell.com/system/" : window.location.origin + "/system/",
	isLogin: Cookies.get("_user", {
		path: "/Home"
	}) || false, //是否登录
	userInfo: {
		NeedChangePass: true
	}, //用户信息
	userRole: {}, //用户权限
	CompanyOPT: sessionStorage.getItem("CompanyOPT") ? JSON.parse(sessionStorage.getItem("CompanyOPT")) : [],
	Company: sessionStorage.getItem("Company") ? JSON.parse(sessionStorage.getItem("Company")) : {
		CityCode: 'G'
	},
	Count: {},
	setIndex: localStorage.getItem("setFPIndex") ? JSON.parse(localStorage.getItem("setFPIndex")) : 0,
	watchInvoiceGroup: localStorage.getItem("watchFPInvoiceGroup") ? JSON.parse(localStorage.getItem("watchFPInvoiceGroup")) : [],
	fullWidth: document.documentElement.clientWidth,
	fullHeight: document.documentElement.clientHeight,
	PageOPT: ['10', '50', '100', '200', '500', '1000'],
	ResponseType: {
		responseType: 'blob'
	},
	paymentSearch: {},
	invoiceSearch: {},
	seesionReBack: sessionStorage.getItem("seesionReBack") ? sessionStorage.getItem("seesionReBack") : null,
	AccountingClassifyOPT: localStorage.getItem("AccountingClassifyOPT") ? JSON.parse(localStorage.getItem("AccountingClassifyOPT")) : [],
	TicketConfigura: localStorage.getItem("TicketFPConfigura") ? JSON.parse(localStorage.getItem("TicketFPConfigura")) : [],
	ReasonListOPT: [],
	DepartmentData: localStorage.getItem("DepartmentOPT") ? JSON.parse(localStorage.getItem("DepartmentOPT")) : {},
	PersonListOPT: localStorage.getItem("PersonListOPT") ? JSON.parse(localStorage.getItem("PersonListOPT")) : [],
	TaxList: [{
			label: "13%",
			value: 13,
		},
		{
			label: "9%",
			value: 9,
		},
		{
			label: "6%",
			value: 6,
		},
		{
			label: "5%",
			value: 5,
		},
		{
			label: "3%",
			value: 3,
		},
		{
			label: "1%",
			value: 1,
		},
		{
			label: "0%",
			value: 0,
		}
	],
	DEPRTMENTTYPEOPT: [{
		label: "业务部",
		value: 0
	}, {
		label: "加油站",
		value: 1
	}, {
		label: "充电站",
		value: 2
	}, {
		label: "养护中心",
		value: 3
	}, {
		label: "便利店",
		value: 4
	}, {
		label: "油库",
		value: 5
	}, {
		label: "中央仓",
		value: 6
	}, {
		label: "服务区",
		value: 7
	}, {
		label: "清净剂库",
		value: 8
	}, {
		label: "质检中心",
		value: 9
	}],
	PMoaDetail: [{
		RoleName: '总经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: true,
		RoleId: 3,
		OrdeNumber: 1
	}, {
		RoleName: '副总经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: true,
		RoleId: 2,
		OrdeNumber: 2
	}, {
		RoleName: '部门经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: true,
		RoleId: 6,
		OrdeNumber: 3
	}, {
		RoleName: '高级区域经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: true,
		RoleId: 7,
		OrdeNumber: 4
	}, {
		RoleName: '区域经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: true,
		RoleId: 8,
		OrdeNumber: 5
	}, {
		RoleName: '工程经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: true,
		RoleId: 9,
		OrdeNumber: 6
	}, {
		RoleName: '财务经理',
		MaxAmount: 0,
		HasOrder: true,
		RoleId: 5,
		OrdeNumber: 7
	}, {
		RoleName: '总经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: false,
		RoleId: 3,
		OrdeNumber: 1
	}, {
		RoleName: '副总经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: false,
		RoleId: 2,
		OrdeNumber: 2
	}, {
		RoleName: '部门经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: false,
		RoleId: 6,
		OrdeNumber: 3
	}, {
		RoleName: '高级区域经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: false,
		RoleId: 7,
		OrdeNumber: 4
	}, {
		RoleName: '区域经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: false,
		RoleId: 8,
		OrdeNumber: 5
	}, {
		RoleName: '工程经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: false,
		RoleId: 9,
		OrdeNumber: 6
	}, {
		RoleName: '财务经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: false,
		RoleId: 5,
		OrdeNumber: 7
	}],
	FMoaDetail: [{
		RoleName: '资金经理',
		MaxAmount: 0,
		MinAmount: 0,
		HasOrder: false,
		RoleId: 13,
		OrdeNumber: 1,
		MoaType: 1
	}],
	OfficeFileType: {
		isWord: "docx",
		isJpg: "gif|jpeg|png|jpg|bmp",
		isOFD: "ofd",
		isExcel: "xlsx",
		isPdf: "pdf",
		isXML:"xml",
		isZip:"rar|zip|arj"
	}
	//	openUPDATE: OPEN_UPDATE
};

export default state


// WEBPACK FOOTER //
// ./src/store/state.js